import type { JSX } from 'react';

/**
 * The masthead logomark: our own outlined shield holding three chart bars (spec ui-direction §8.3).
 * Deliberately not the PPA badge — this site cites the police, it does not wear them.
 */
export function ShieldMark(): JSX.Element {
  return (
    <svg viewBox="0 0 30 34" fill="none" aria-hidden="true" className="block h-[34px] w-[30px]">
      <title>Politseikroonika</title>
      <path
        d="M15 1.5 27.5 6v10.2c0 7.6-5 13.3-12.5 16.3C7.5 29.5 2.5 23.8 2.5 16.2V6L15 1.5Z"
        stroke="var(--color-accent-deep)"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <rect x="8.6" y="16" width="3.4" height="7" rx="1.2" fill="var(--color-accent)" />
      <rect x="13.3" y="11" width="3.4" height="12" rx="1.2" fill="var(--color-accent)" />
      <rect x="18" y="14" width="3.4" height="9" rx="1.2" fill="var(--color-caution)" />
    </svg>
  );
}
